import { GetWorkerSalaryListResponse } from '@/services';

import { formatDate, map, showDataGridWithSymbol } from 'utils';

export const formatWorkerSalaryDetail = (
	input: GetWorkerSalaryListResponse['content'][number]
) => {
	const applicantSalaryStartTime = formatDate(input.applicantSalaryStartTime, {
		inputFormat: 'HH:mm',
		outputFormat: 'HH:mm',
	});
	const applicantSalaryEndTime = formatDate(input.applicantSalaryEndTime, {
		inputFormat: 'HH:mm',
		outputFormat: 'HH:mm',
	});
	return {
		...input,
		id: input?.applicantSalaryId,
		applicantSalaryWorkingDate: formatDate(input?.applicantSalaryWorkingDate),
		applicantSalaryHourlyWage:
			input?.applicantSalaryHourlyWage?.toLocaleString?.('ko-KR') || '-',
		applicantSalaryGrade:
			input?.applicantSalaryGrade?.replace?.('GRADE_', '') || '',
		applicantSalaryPublicFranchiseId: String(
			input.applicantSalaryPublicFranchiseId
		),
		applicantSalaryStartTime,
		applicantSalaryEndTime,
		applicantSalaryPeriod: showDataGridWithSymbol(
			applicantSalaryStartTime,
			applicantSalaryEndTime,
			'~'
		),
	};
};

export const formatWorkerSalaryList = (
	input: GetWorkerSalaryListResponse['content']
) => {
	return map(input, formatWorkerSalaryDetail);
};

export const formatWorkerSalaryExcelList = (
	input: GetWorkerSalaryListResponse['content']
) => {
	return map(input, (item) => {
		return {
			...formatWorkerSalaryDetail(item),
			applicantSalarySalary:
				item?.applicantSalarySalary?.toLocaleString?.('ko-KR') || '-',
			applicantSalaryRelaxTime: item?.applicantSalaryRelaxTime
				? `${item?.applicantSalaryRelaxTime} 시간`
				: '',
		};
	});
};

export const convertTimeToObject = (timeString: string) => {
	const [hours, minutes] = timeString.split(':');
	return {
		hour: parseInt(hours),
		minute: parseInt(minutes),
		second: 0,
		nano: 0,
	};
};
